module.exports = __webpack_public_path__ + "static/media/hb-prime-landing.97d2d7c8.svg";